export const IconChevronLeft = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M15.457 19.207a1 1 0 0 0 0-1.414L9.664 12l5.793-5.793a1 1 0 0 0-1.414-1.414L8.25 10.586a2 2 0 0 0 0 2.828l5.793 5.793a1 1 0 0 0 1.414 0"
        clipRule="evenodd"
      />
    </svg>
  );
};
